import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/images/about_1.webp")